import React from 'react';
import TeamInquiryTable from './TeamInquiryTable';
import TeamReceivedInquiryBidsTable from './TeamReceivedInquiryBidsTable';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  table: {
    marginBottom: theme.spacing(5)
  }
}))
export default function TeamInquiriesPage() {
  const classes = useStyles();
  return (
    <Box>
      <Box className={classes.table}>
        <TeamInquiryTable />
      </Box>
      <Box className={classes.table}>
        <TeamReceivedInquiryBidsTable />
      </Box>
    </Box>
  )
}
